import React, { useEffect, useState } from 'react';
import { marked } from 'marked';

interface CitationTextProps {
  /** The raw text containing citations in the form ‹citationId› */
  text: string;
  /** Called when a citation is clicked; receives the citation ID string */
  onCiteClick: (id: string) => void;
  citationObject: { [key: string]: number };
}
const citeRegex = /<<cid:([A-Fa-f0-9]{24})>>/g;
export const CitationTextValidation: React.FC<CitationTextProps> = ({
  text,
  onCiteClick,
  citationObject
}) => {
  const [html, setHtml] = useState('');
  const [tooltipText, setTooltipText] = useState('Click to copy');

  const convertMarkdown = async () => {
    console.log('citation object validation function', citationObject);
    // const htmlWithCitations = await marked.parse(text);
    const replacedHtml = text.replace(
      // const replacedHtml = htmlWithCitations.replace(
      // /‹([^›]*)›/g,
      citeRegex,
      (_, citationId) => {
        // console.log('citation object props', citationObject);
        const citationLabel = citationObject[`${citationId}`];
        console.log('line 29 citation label', citationLabel);
        return `<span class="text-blue-600 underline cursor-pointer" data-citation-id="${citationId}">&lt;${citationLabel}&gt;</span>`;
      }
    );
    setHtml(replacedHtml);
  };
  useEffect(() => {
    convertMarkdown();
  }, []);
  useEffect(() => {
    convertMarkdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, citationObject]);

  const copyToClipboard = async () => {
    const regex = /‹[a-f0-9]{24}›/;
    const result = text.replace(regex, '');
    await navigator.clipboard.writeText(result);
    setTooltipText('Copied!');
    setTimeout(() => setTooltipText('Click to copy'), 2000);
  };

  return (
    <div className="prose prose-sm text-gray-800">
      <div
        dangerouslySetInnerHTML={{ __html: html }}
        onClick={(e) => {
          const target = e.target as HTMLElement;
          if (target.dataset.citationId) {
            onCiteClick(target.dataset.citationId);
          }
        }}
      />
    </div>
  );
};
